import { ReactElement } from "react";
import { NoResults, NoResultsProps } from "../NoResults/NoResults";
import { setTrackingId } from "client/Misc/utils";
import styles from "./ActionListItem.module.less";
import classNames from "classnames";

export type ActionListNoResultsProps = NoResultsProps;

export const ActionListNoResults = (props: ActionListNoResultsProps): ReactElement => {
	const {
		trackingId,
		...restOfProps
	} = props;

	return (
		<li
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				styles.root_noResults
			)}
		>
			<NoResults
				{...restOfProps}
			/>
		</li>
	);
};
ActionListNoResults.displayName = "ActionListNoResults";